const API_BASE_URL = 'https://www.mmfireworks.com/backend';

export default API_BASE_URL;